module.exports = __webpack_public_path__ + "img/soccerboard54.a3363689.jpg";